import { Box } from '@mui/material';

import ClientSignsSymptoms from './ClientSignsSymptoms';
import EvidencedBasedInterventions from './EvidencedBasedInterventions';
import { ChecklistSection } from './components';
import { SYMPTOMS_INTERVENTIONS_ROOT_SX } from './styles';
import { hasNoFieldChecked } from '../../utils';

import type { ChecklistFieldValue, SymptomsAndInterventionsProps } from './types';

function SymptomsAndInterventions({
  evidence_based_interventions_used,
  isEditable,
  session,
  showErrors,
  signs_and_symptoms_observed,
  updateFieldValue,
  useNewUi,
}: SymptomsAndInterventionsProps) {
  if (useNewUi) {
    return (
      <Box sx={SYMPTOMS_INTERVENTIONS_ROOT_SX}>
        <ClientSignsSymptoms
          title="Signs/Symptoms observed"
          subtitle="Select all that apply to the client"
          errorMessage="At least one sign/symptom observed is required"
          hasError={
            showErrors &&
            hasNoFieldChecked(
              { signs_and_symptoms_observed: signs_and_symptoms_observed },
              'signs_and_symptoms_observed',
            )
          }
          isEditable={isEditable}
          data={signs_and_symptoms_observed}
          useNewUi={useNewUi}
          onChange={(key: string, value: ChecklistFieldValue) =>
            updateFieldValue('signs_and_symptoms_observed', {
              [key]: value,
            })
          }
        />
        <EvidencedBasedInterventions
          title="Evidence-based interventions used"
          subtitle="Select all that apply to the client"
          errorMessage="At least one evidence based intervention is required"
          hasError={
            showErrors &&
            hasNoFieldChecked(
              { evidence_based_interventions_used: evidence_based_interventions_used },
              'evidence_based_interventions_used',
            )
          }
          isEditable={isEditable}
          data={evidence_based_interventions_used}
          useNewUi={useNewUi}
          onChange={(key: string, value: ChecklistFieldValue) =>
            updateFieldValue('evidence_based_interventions_used', {
              [key]: value,
            })
          }
        />
      </Box>
    );
  }

  return (
    <Box sx={SYMPTOMS_INTERVENTIONS_ROOT_SX}>
      <ChecklistSection
        title="Signs/Symptoms observed"
        subtitle="Select all that apply to the client"
        errorMessage="At least one sign/symptom observed is required"
        hasError={
          showErrors &&
          hasNoFieldChecked(
            { signs_and_symptoms_observed: signs_and_symptoms_observed },
            'signs_and_symptoms_observed',
          )
        }
        session={session}
        useNewUi={useNewUi}
      >
        <ClientSignsSymptoms
          isEditable={isEditable}
          data={signs_and_symptoms_observed}
          useNewUi={useNewUi}
          onChange={(key: string, value: ChecklistFieldValue) =>
            updateFieldValue('signs_and_symptoms_observed', {
              [key]: value,
            })
          }
        />
      </ChecklistSection>
      <ChecklistSection
        title="Evidence-based interventions used"
        subtitle="Select all that apply to the client"
        errorMessage="At least one evidence based intervention is required"
        hasError={
          showErrors &&
          hasNoFieldChecked(
            { evidence_based_interventions_used: evidence_based_interventions_used },
            'evidence_based_interventions_used',
          )
        }
        session={session}
        useNewUi={useNewUi}
      >
        <EvidencedBasedInterventions
          isEditable={isEditable}
          data={evidence_based_interventions_used}
          useNewUi={useNewUi}
          onChange={(key: string, value: ChecklistFieldValue) =>
            updateFieldValue('evidence_based_interventions_used', {
              [key]: value,
            })
          }
        />
      </ChecklistSection>
    </Box>
  );
}

export default SymptomsAndInterventions;
